const TOKEN_ACESSO = "manager_token";

function salvarTokenAcesso(token) {
  localStorage.setItem(TOKEN_ACESSO, token);
}

function invalidarSessao() {
  localStorage.removeItem(TOKEN_ACESSO);
}

function getTokenAcesso() {
  return localStorage.getItem(TOKEN_ACESSO);
}

export default {
  TOKEN_ACESSO,
  salvarTokenAcesso,
  invalidarSessao,
  getTokenAcesso
};
